interface Props {
  holeNum: number;
  par: number;
  yards?: number | null;
  height?: number;
  showLabel?: boolean;
}

function buildShape(par: number) {
  const type = par === 3 ? 'p3' : par === 5 ? 'p5' : 'p4';
  if (type === 'p3') {
    return {
      fairway: 'M 30 110 Q 50 60 70 35 Q 50 25 50 20',
      green: { cx: 50, cy: 22, rx: 12, ry: 8 },
      flag: { x: 50, y: 22 },
      teeBox: { x: 30, y: 108, w: 8 },
    };
  }
  if (type === 'p5') {
    return {
      fairway: 'M 25 125 Q 35 90 45 70 Q 55 45 65 30 Q 55 20 50 18',
      green: { cx: 50, cy: 20, rx: 11, ry: 7 },
      flag: { x: 50, y: 20 },
      teeBox: { x: 22, y: 122, w: 10 },
    };
  }
  return {
    fairway: 'M 28 120 Q 40 85 55 55 Q 65 35 58 25 Q 50 18 48 16',
    green: { cx: 48, cy: 18, rx: 10, ry: 7 },
    flag: { x: 48, y: 18 },
    teeBox: { x: 26, y: 117, w: 9 },
  };
}

export function HoleIllustration({ holeNum, par, yards, height = 100, showLabel = true }: Props) {
  const shape = buildShape(par);
  const gid = `hole-${holeNum}-${par}`;

  return (
    <svg
      viewBox="0 0 100 140"
      width="100%"
      height={height}
      preserveAspectRatio="xMidYMid meet"
      className="block rounded-md bg-[#f1ead7]"
    >
      <defs>
        <radialGradient id={`${gid}-bg`} cx="50%" cy="60%" r="80%">
          <stop offset="0%" stopColor="#f1ead7" />
          <stop offset="100%" stopColor="#ebe3c8" />
        </radialGradient>
      </defs>
      <rect x="0" y="0" width="100" height="140" fill={`url(#${gid}-bg)`} />
      <g opacity="0.55" transform="translate(50, 70) scale(1.18, 1.04) translate(-50, -70)">
        <path d={shape.fairway} fill="#c8d39a" />
      </g>
      <path d={shape.fairway} fill="#a3bd6e" stroke="#8aa55f" strokeWidth="0.3" />
      <ellipse cx={shape.green.cx} cy={shape.green.cy} rx={shape.green.rx} ry={shape.green.ry} fill="#5e7d35" stroke="#3d5520" strokeWidth="0.4" />
      <line x1={shape.flag.x} y1={shape.flag.y - 1} x2={shape.flag.x} y2={shape.flag.y - 9} stroke="#1a1a1a" strokeWidth="0.6" />
      <path d={`M ${shape.flag.x} ${shape.flag.y - 9} L ${shape.flag.x + 5} ${shape.flag.y - 7.5} L ${shape.flag.x} ${shape.flag.y - 6} Z`} fill="#b42828" />
      <g transform={`translate(${shape.teeBox.x + shape.teeBox.w / 2}, ${shape.teeBox.y + 1})`}>
        <rect x={-shape.teeBox.w / 2} y={-1.5} width={shape.teeBox.w} height={3} fill="#9e8a5e" rx="0.5" />
        <circle cx="0" cy="0" r="1.2" fill="#1f4ea3" />
      </g>
      <g transform={`translate(${Math.min(shape.green.cx + shape.green.rx + 6, 92)}, ${shape.green.cy})`}>
        <circle cx="0" cy="0" r="5" fill="#1a1a1a" />
        <text x="0" y="0.5" textAnchor="middle" dominantBaseline="central" fontFamily="system-ui, sans-serif" fontSize="6" fontWeight="700" fill="#f1ead7">
          {holeNum}
        </text>
      </g>
      {showLabel && (
        <g>
          <line x1="10" y1="135" x2="90" y2="135" stroke="#2a2a2a" strokeWidth="0.3" opacity="0.4" />
          <text x="22" y="139" textAnchor="middle" fontFamily="system-ui, sans-serif" fontSize="4.5" fontWeight="700" fill="#2a2a2a">
            PAR {par}
          </text>
          <text x="78" y="139" textAnchor="middle" fontFamily="system-ui, sans-serif" fontSize="4.5" fontWeight="700" fill="#2a2a2a">
            {yards ?? '—'} YDS
          </text>
        </g>
      )}
    </svg>
  );
}
